import { getLeads } from '../../../apiclient/resources/leads';
import { buildFilter } from '../../../services/utils/leads';
import * as actions from './actions';

const getLeadsCounter = (status, postingId) => dispatch => {
  dispatch(actions.fetchLeads(status, postingId));
  getLeads(
    0,
    undefined,
    1,
    buildFilter('status', status) +
      buildFilter('posting_id', postingId) +
      buildFilter('spam', status.indexOf('spam') !== -1 ? 'true' : 'false')
  ).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchLeadsSucceeded(data.paging.total));
    } else {
      dispatch(actions.fetchLeadsFailed());
    }
  });
};

export const { addFilter, removeFilter, setFilter, fetchLeads, fetchLeadsFailed, fetchLeadsSucceeded } = actions;

export { getLeadsCounter };
